<template>
	<div class="path">
		<template v-for="(sp, idx) in pages">
			<template v-if="idx > 0">&nbsp;<span class='parr'>&rarr;</span>&nbsp;</template>
			<span v-if="isLastPage(idx)" class="path-last">{{ sp.title }}</span>
			<it-link v-else :to="pagePath(sp, idx)">{{ sp.title }}</it-link>
		</template>
	</div>
</template>

<script setup lang="ts">
import {StackPage} from "@t/meta/Stacker";
import ItLink from "@/router/ItLink.vue";
import {injectEnv} from "@fd/Environment";

const props = defineProps<{
	pages: StackPage[]
}>();

const env = injectEnv();

function isLastPage(idx: number):boolean {
	return idx == (props.pages.length - 1);
}

function pagePath(sp:StackPage, idx: number):string {
	if (sp.path) {
		let path = sp.path;
		if (Server.context && Server.context !== "/") path = Server.context + path;
		if (sp.attributes) {
			for (let key of Object.keys(sp.attributes)) {
				path = env.net.urlParam(path, key, sp.attributes[key]);
			}
		}
		path = env.net.urlParam(path, "_sidx_", idx);
		return path;
	}
	return "#";
}
</script>

<style>

</style>